module.exports = __webpack_public_path__ + "KaTeX_AMS-Regular.4b0fee78.woff";